import { UNIT, mainColor } from '../../constants/theme';

export const styles = () => ({
  progress: {
    margin: UNIT * 2,
    textAlign: 'center',
    color: mainColor.secondaryColor,
    marginTop: UNIT * 1.25,
    marginBottom: UNIT * 1.25
  },
  body: {
    width: '100%',
    display: 'flex',
    padding: '10px 10px 0px 10px'
  },

  paper: {
    marginTop: UNIT * 0.625,
    width: '100%',
    height: UNIT * 21.625
  },
  configPaper: {
    marginTop: UNIT * 0.625,
    width: '100%',
    height: UNIT * 30.1875
  },
  additionPaper: {
    marginTop: UNIT * 0.625,
    width: '100%',
    height: UNIT * 26.0625
  },
  paperStyle: {
    width: '100%',
    borderRadius: '0px 16px 16px 0px!important'
  },

  root: {
    borderTop: `0.1px solid #eeeeee`,
    textAlign: 'center',
    margin: 'auto'
  },

  designStyle: {
    width: 'fit-content',
    margin: 'auto'
  },

  marginStyle: {
    marginTop: -UNIT * 0.625
  },

  imageWidth: {
    width: UNIT * 1.625
  },

  listItemStyle: {
    fontWeight: 'bold',
    color: 'black!important',
    marginLeft: `${-UNIT * 0.625}px!important`
  },

  spaceLeft: {
    marginLeft: UNIT * -0.5,
    padding: '0px',
    marginTop: UNIT * -0.5
  },
  switch: {
    marginRight: UNIT * -1.4375
  },
  hrStyle: {
    margin: '0px 2px 22px -9px'
  },
  buttonStyle: {
    width: '100%'
  },
  disabledButton: {
    backgroundColor: '#989898!important',
    borderColor: '#989898!important'
  }
});
